import { ForgotPasswordView } from "@components";

export const ForgotPassword = () => {
    return (
        <>
            <ForgotPasswordView />
        </>
    );
};
